<template>
  <div class="infrastructure-wrapper">
    <div class="checkbox-row infrastructure-row">
      <v-checkbox
        :readonly="readonly"
        class="prep-left"
        v-model="wheelchair"
        label="Rollstuhl geeignet"
        color="#33bbff"
        hide-details
      ></v-checkbox>

      <v-checkbox
        :readonly="readonly"
        v-model="stroller"
        label="Kinderwagen geeignet"
        color="#33bbff"
        hide-details
      ></v-checkbox>
    </div>
    <div class="checkbox-row infrastructure-row">
      <v-checkbox
        :readonly="readonly"
        class="prep-left"
        v-model="transportation"
        label="Erreichbar mit ÖV"
        color="#33bbff"
        hide-details
      ></v-checkbox>
      <v-checkbox
        :readonly="readonly"
        v-model="picnic"
        label="Picknicktisch"
        color="#33bbff"
        hide-details
      ></v-checkbox>
    </div>
    <div class="checkbox-row infrastructure-row">
      <v-checkbox
        :readonly="readonly"
        class="prep-left"
        v-model="parking"
        label="Parkplätze"
        color="#33bbff"
        hide-details
      ></v-checkbox>
      <v-checkbox
        :readonly="readonly"
        v-model="playground"
        label="Spielplatz"
        color="#33bbff"
        hide-details
      ></v-checkbox>
    </div>
    <div class="checkbox-row infrastructure-row">
      <v-checkbox
        :readonly="readonly"
        class="prep-left"
        v-model="dogs"
        label="Hunde erlaubt"
        color="#33bbff"
        hide-details
      ></v-checkbox>
      <v-checkbox
        :readonly="readonly"
        v-model="restaurant"
        label="Restaurant / Kiosk"
        color="#33bbff"
        hide-details
      ></v-checkbox>
    </div>
    <div class="checkbox-row infrastructure-row">
      <v-checkbox
        :readonly="readonly"
        class="prep-left"
        v-model="drinking"
        label="Trinkwasser"
        color="#33bbff"
        hide-details
      ></v-checkbox>
      <v-checkbox
        :readonly="readonly"
        v-model="toilet"
        label="WC"
        color="#33bbff"
        hide-details
      ></v-checkbox>
    </div>
    <div class="checkbox-row infrastructure-row">
      <v-checkbox
        :readonly="readonly"
        v-model="firepit"
        label="Feuerstelle"
        color="#33bbff"
        hide-details
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "readonly"],
  data() {
    return {
      wheelchair: this.value.wheelchair,
      stroller: this.value.stroller,
      firepit: this.value.firepit,
      transportation: this.value.transportation,
      picnic: this.value.picnic,
      parking: this.value.parking,
      playground: this.value.playground,
      dogs: this.value.dogs,
      restaurant: this.value.restaurant,
      drinking: this.value.drinking,
      toilet: this.value.toilet,
    };
  },
  methods: {
    changeCheckbox() {
      console.log("AND CHANGE");
      this.$emit("input", {
        wheelchair: this.wheelchair,
        stroller: this.stroller,
        firepit: this.firepit,
        transportation: this.transportation,
        picnic: this.picnic,
        parking: this.parking,
        playground: this.playground,
        dogs: this.dogs,
        restaurant: this.restaurant,
        drinking: this.drinking,
        toilet: this.toilet,
      });
    },
  },
  mounted() {
    console.log("infra", this.value);
  },
  computed: {},
  watch: {
    wheelchair: function (newData, oldData) {
      this.changeCheckbox();
    },
    stroller: function (newData, oldData) {
      this.changeCheckbox();
    },
    firepit: function (newData, oldData) {
      this.changeCheckbox();
    },
    transportation: function (newData, oldData) {
      this.changeCheckbox();
    },
    picnic: function (newData, oldData) {
      this.changeCheckbox();
    },
    parking: function (newData, oldData) {
      this.changeCheckbox();
    },
    playground: function (newData, oldData) {
      this.changeCheckbox();
    },
    dogs: function (newData, oldData) {
      this.changeCheckbox();
    },
    restaurant: function (newData, oldData) {
      this.changeCheckbox();
    },
    drinking: function (newData, oldData) {
      this.changeCheckbox();
    },
    toilet: function (newData, oldData) {
      this.changeCheckbox();
    },
  },
};
</script>

<style>
</style>
